import { Box, Skeleton } from "@mui/material";

type ProjectDetailSkeletonProps = {
  sections?: number[];
};

const SectionCardSkeleton = ({ rows }: { rows: number }) => (
  <Box
    sx={{
      margin: "20px 0",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "custom.greyish.6",
      padding: "15px 20px",
      borderRadius: "15px",
      maxWidth: { xs: "100%", lg: "60%" },
    }}
  >
    {/* section heading with its underline (mirrors styles.heading) */}
    <Box
      sx={{
        paddingBottom: "10px",
        marginBottom: "15px",
        borderBottomWidth: "1px",
        borderBottomStyle: "solid",
        borderBottomColor: "primary.main",
      }}
    >
      <Skeleton
        variant="text"
        animation="wave"
        height={28}
        sx={{ width: "45%", maxWidth: 280 }}
      />
    </Box>

    {/* label : value rows */}
    {Array.from({ length: rows }).map((_, index) => (
      <Box
        key={index}
        sx={{
          display: "flex",
          gap: "6%",
          alignItems: "center",
          padding: "9px 0",
        }}
      >
        <Skeleton
          variant="text"
          animation="wave"
          height={20}
          sx={{ width: "26%" }}
        />
        <Skeleton
          variant="text"
          animation="wave"
          height={20}
          sx={{ width: index % 2 === 0 ? "42%" : "34%" }}
        />
      </Box>
    ))}
  </Box>
);

const ProjectDetailSkeleton = ({
  sections = [5, 9, 6],
}: ProjectDetailSkeletonProps) => {
  return (
    <Box aria-busy="true">
      {/* registration-number title */}
      <Skeleton
        variant="text"
        animation="wave"
        height={44}
        sx={{ width: "40%", maxWidth: 420, marginBottom: "8px" }}
      />

      {sections.map((rows, index) => (
        <SectionCardSkeleton key={index} rows={rows} />
      ))}
    </Box>
  );
};

export default ProjectDetailSkeleton;
